export enum PendingBannerModalStateEnum {
  Initial = 0,
  SavedAsDefault = 1,
  NotSavedAsDefault = 2
}